import React, { useState } from 'react'
import { Icon, Typography, Card, Checkbox, MenuList } from '@material-ui/core'
import * as R from 'ramda'
import { TruncatedTextWithTooltip } from 'app/components/TruncatedTextWithTooltip'
import { useDispatch, useSelector } from 'react-redux'
import effects from 'app/effects/effects'
import FetchTable from 'app/components/table/FetchTable'
import { useIntl, FormattedMessage } from 'react-intl'
import { withAvatarColumn } from 'app/components/table/TableColumn'
import appConfigs from 'app/configs/appConfigs'
import moment from 'moment'
import StatusChips from 'app/components/StatusChips'
import TrashButton from 'app/components/buttons/TrashButton'
import TopicCardDialog from 'app/main/topics/TopicCardDialog'
import {
  closeTopicDialog,
  openTopicDialog,
  getTopicDetail,
  topicNameError,
} from 'app/main/topics/store/actions/topic-action'

import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import { TOPIC_CARD_STATUS } from './configs/constants'
import { useTableFetch, pageToSortPairs } from 'commons/reactTableFetch'
import MessageAlert from 'app/components/MessageAlert'
import DeleteDialogSuscribers from './DeleteSuscribers'
import AddSubscribers from './AddSubscribers'
import { matchPath } from 'react-router'
import { withFirstColumn } from 'app/components/table/TableColumn'
import TableMultiSelectMenu from 'app/components/TableMultiSelectMenu'
import DeleteMenuItem from 'app/components/table/DeleteMenuItem'

const useStyles = makeStyles((theme) => ({
  cardDetail: {
    borderRadius: 0,
    position: 'relative',
    width: '100%',
    overflowY: 'auto',
    padding: '15px 0',
    margin: '0 0 15px 0',
    [theme.breakpoints.up('sm')]: {
      margin: '0 15px 15px 0',
      width: 380,
      height: 'fit-content',
    },
  },
  detailLabel: {
    fontWeight: 700,
    padding: '0.75rem 1.6rem',
  },
  detailDesc: {
    fontWeight: 400,
  },
  topicTable: {
    '& .rt-thead': {
      '@media(max-width:700px)': {
        width: '900px',
      },
      '@media(max-width:412px)': {
        width: '1100px',
      },
    },
    '& .rt-tbody': {
      '@media(max-width:700px)': {
        width: '900px',
      },
      '@media(max-width:412px)': {
        width: '1100px',
      },
    },
  },
  textActive: {
    color: theme.palette.active.main,
  },
  textInactive: {
    color: '#f74872',
  },
  restrictedText: {
    color: theme.palette.primary.subtitle,
  },
  emptyContainer: {
    marginLeft: 15,
  },
}))

const headerStyle = {
  textAlign: 'left',
  fontSize: 13,
  fontWeight: 'bold',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
}

const headerStyleThree = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const cellStyleTwo = {
  color: '#c5c5c5',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}

const fetchData = (id) => (page) => {
  return effects.apis.getSubscribersFollowTopics({
    topicsId: id,
    page: page.currentPage,
    limit: page.pageSize,
    keyword: page.keyword,
    sort: pageToSortPairs(page),
  })
}

export default (props) => {
  const match = matchPath(props.history.location.pathname, {
    path: '/topics/:topicsId',
  })

  const setNameError = (error) => {
    if (Number(error.response.data.details.code) === 697) {
      dispatch(topicNameError())
      return
    }
  }

  const topicId = R.path(['params', 'topicsId'], match)
  const classes = useStyles()
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const {
    dialogState,
    isOpenTopicDialog,
    subscriberTopics,
    isOpenAddSubscribers,
  } = useSelector((state) => state.topicReducer)

  const [isOpentDelete, setIsOpentDelete] = useState(false)
  const [subscriberId, setSubscriberId] = useState([])

  const tableFetch = useTableFetch(fetchData(props.match.params.topicsId))
  const {
    pageInfo,
    defaultPageSize,
    onFetchData,
    refetchData: refetchTableSubscribers,
    startFetchData,
    endFetchData,
    showPagination,
    toggleSelectAll,
    toggleSelect,
  } = tableFetch

  const DisplayWithHideContactsLogic = ({ original, value, render }) => {
    if (original.hideContacts === 1) {
      return (
        <Typography className={clsx('italic', classes.restrictedText)}>
          <FormattedMessage id="subscriber.label.restricted" />
        </Typography>
      )
    }
    return R.isNil(render) ? '' : render
  }

  const renderTableMenu = () => {
    return (
      <TableMultiSelectMenu>
        {(closeMenu) => (
          <MenuList>
            <DeleteMenuItem
              onClick={() => {
                closeMenu()
                setSubscriberId(R.prop('checkedIds', pageInfo))
                setIsOpentDelete(true)
              }}
              selectedCount={R.length(pageInfo.checkedIds)}
            />
          </MenuList>
        )}
      </TableMultiSelectMenu>
    )
  }

  const columns = [
    withFirstColumn({
      Header: () => (
        <div>
          <Checkbox
            color="secondary"
            onClick={(event) => {
              event.stopPropagation()
            }}
            onChange={(event) => {
              toggleSelectAll(event.target.checked)
            }}
            checked={pageInfo.isCheckedAll}
            indeterminate={pageInfo.isIndeterminated}
          />
          {!R.isEmpty(pageInfo.checkedIds) && renderTableMenu()}
        </div>
      ),
      Cell: (row) => {
        return (
          <div className="flex">
            <Checkbox
              onClick={(event) => {
                event.stopPropagation()
              }}
              color="secondary"
              checked={pageInfo.checkedIds.includes(row.value.id)}
              onChange={() => {
                toggleSelect(row.value.id)
              }}
            />
          </div>
        )
      },
      className: clsx('sticky'),
      headerClassName: clsx('sticky'),
    }),
    withAvatarColumn(),
    {
      Header: formatMessage({ id: 'firstName.label' }),
      accessor: 'firstName',
      id: 'firstName',
      filterable: true,
      width: 120,
    },
    {
      Header: formatMessage({ id: 'lastName.label' }),
      accessor: 'lastName',
      id: 'lastName',
      filterable: true,
      width: 120,
    },
    {
      Header: formatMessage({ id: 'subscriber.label.language' }),
      accessor: 'language',
      id: 'language',
      Cell: (props) => (props.value ? props.value['name'] : ''),
      filterable: false,
      width: 180,
      sortable: false,
    },
    {
      Header: formatMessage({ id: 'subscriber.label.dateOfBirth' }),
      accessor: 'birthday',
      id: 'birthday',
      Cell: (props) => (
        <DisplayWithHideContactsLogic
          {...props}
          render={R.compose(
            R.unless(
              R.isNil,
              R.compose((a) => a.format(appConfigs.dateFormat), moment),
            ),
            R.prop('value'),
          )(props)}
        />
      ),
      filterable: true,
      sortable: false,
      width: 130,
    },
    {
      Header: formatMessage({ id: 'email.address.label' }),
      accessor: 'email',
      headerStyle,
      Cell: (props) => (
        <DisplayWithHideContactsLogic {...props} render={props.value} />
      ),
      width: 160,
    },
    {
      id: 'phone',
      Header: formatMessage({ id: 'phone.label' }),
      accessor: 'fullPhoneNumber',
      headerStyle,
      Cell: (props) => (
        <DisplayWithHideContactsLogic {...props} render={props.value} />
      ),
      width: 120,
    },
    {
      accessor: 'status',
      id: 'status',
      width: 130,
      Header: formatMessage({ id: 'text.status' }),
      Cell: (props) => (
        <StatusChips status={props.original.lastInvitationStatus || 0} />
      ),
    },
    {
      accessor: 'unFollowTopicSubscriber',
      Cell: ({ original }) => {
        return (
          <div className="flex w-full justify-end">
            <TrashButton
              onClick={() => {
                setSubscriberId([R.prop('id', original)])
                setIsOpentDelete(true)
              }}
            />
          </div>
        )
      },
      Header: () => null,
      width: 80,
      headerStyle: headerStyleThree,
      style: cellStyleTwo,
      show: Boolean(R.prop('isActive', dialogState)),
    },
  ]

  const handleSubmitTopicCard = async (data) => {
    try {
      if (R.has('id', data)) {
        await effects.apis.updateTopic(data)
        await dispatch(getTopicDetail(topicId))
      }
      await dispatch(closeTopicDialog())
    } catch (error) {
      await setNameError(error)
    }
  }

  const topicStatus = (formatMessage) => (status) => {
    switch (status) {
      case TOPIC_CARD_STATUS.ACTIVE:
        return formatMessage({ id: 'status.active' })
      case TOPIC_CARD_STATUS.INACTIVE:
        return formatMessage({ id: 'status.inactive' })
      default:
        return null
    }
  }

  const setColorStatus = (status, classes) => {
    switch (status) {
      case TOPIC_CARD_STATUS.ACTIVE:
        return classes.textActive
      case TOPIC_CARD_STATUS.INACTIVE:
        return classes.textInactive
      default:
        return null
    }
  }

  const onDeleteSuccessPromise = () => {
    startFetchData()
    return refetchTableSubscribers().then(endFetchData)
  }

  const handleFollower = (props) => {
    const isActive = R.prop('isActive', props)
    const subscribersCount = R.prop('subscribersCount', props)
    const inactiveFollower = R.prop('inactiveFollower', props)

    return isActive !== 0 ? subscribersCount : inactiveFollower
  }

  return (
    <>
      <div className="flex flex-col overflow-hidden">
        <div className="flex flex-col flex-auto sm:flex sm:flex-row overflow-hidden">
          <Card className={classes.cardDetail}>
            <div className="flex justify-between px-16">
              <TruncatedTextWithTooltip
                text={R.prop('name', dialogState) || ''}
                typographyProps={{
                  variant: 'h6',
                }}
              />
              <Icon
                className="cursor-pointer ltr:pr-8 rtl:pl-8"
                fontSize="small"
                onClick={() => dispatch(openTopicDialog())}
              >
                create_outlined_icon
              </Icon>
            </div>
            <Typography className={classes.detailLabel}>
              <FormattedMessage
                id="topics.detail.status"
                values={{
                  status: R.o(
                    topicStatus(formatMessage),
                    R.prop('isActive'),
                  )(dialogState),
                  color: (text) => (
                    <span
                      className={clsx(
                        classes.detailDesc,
                        setColorStatus(
                          R.prop('isActive', dialogState) || 0,
                          classes,
                        ),
                      )}
                    >
                      {text}
                    </span>
                  ),
                }}
              />
            </Typography>
            <Typography className={classes.detailLabel}>
              <FormattedMessage
                id="topics.detail.description"
                values={{
                  description: R.prop('description', dialogState),
                  newLine: <br />,
                  l: (text) => (
                    <span className={classes.detailDesc}>{text}</span>
                  ),
                }}
              />
            </Typography>
            <Typography className={classes.detailLabel}>
              <FormattedMessage
                id="topics.detail.followers"
                values={{
                  follows: handleFollower(dialogState),
                  color: (text) => (
                    <span className={classes.detailDesc}>{text}</span>
                  ),
                }}
              />
            </Typography>
            <Typography className={classes.detailLabel}>
              <FormattedMessage
                id="topics.detail.messages"
                values={{
                  notificationsCount: R.prop('notificationsCount', dialogState),
                  color: (text) => (
                    <span className={classes.detailDesc}>{text}</span>
                  ),
                }}
              />
            </Typography>
          </Card>

          <div className="h-full overflow-hidden flex flex-col flex-auto">
            <FetchTable
              FilterComponent={null}
              page={pageInfo.page}
              pages={pageInfo.total}
              data={pageInfo.data}
              error={pageInfo.error}
              refetchData={refetchTableSubscribers}
              className={classes.topicTable}
              noDataText={formatMessage({
                id: 'topicDetail.subscriber.table.empty.label',
              })}
              defaultPageSize={defaultPageSize}
              manual
              loading={pageInfo.isLoading}
              onFetchData={onFetchData}
              columns={columns}
              showPagination={showPagination}
              total={pageInfo.totalData}
            />
          </div>
        </div>
      </div>
      <TopicCardDialog
        onSubmit={handleSubmitTopicCard}
        onClose={() => {
          dispatch(closeTopicDialog())
        }}
        dialogState={dialogState}
        isOpen={isOpenTopicDialog}
      />
      <DeleteDialogSuscribers
        isOpen={isOpentDelete}
        onClose={() => {
          setIsOpentDelete(false)
        }}
        topic={dialogState}
        subscriberId={subscriberId}
        onChange={() => {
          onDeleteSuccessPromise()
          dispatch(getTopicDetail(topicId))
        }}
      />
      <AddSubscribers
        topics={dialogState}
        subscriberList={subscriberTopics}
        isOpen={isOpenAddSubscribers}
        onChange={() => {
          refetchTableSubscribers()
          dispatch(getTopicDetail(topicId))
        }}
      />
    </>
  )
}
